var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-container',{attrs:{"horizontal-end":"","vertical-center":""}},[_c('base-icon',{attrs:{"icon":"fas fa-envelope","color":"text-secondary"}}),_c('base-text',{staticClass:"ml-2",attrs:{"value":"営業メールを送付した日"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }